import MontserratReg from "../assets/fonts/Montserrat-Regular.woff2";



export const montserratRegular = {
  fontFamily: "Montserrat-Regular",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 300,
  src: `
    local('Montserrat-Regular'),
    url(${MontserratReg}) format('woff2'),
  `,
};